import React, { useState, useEffect } from "react";
import Layout from "../layout/Layout";
import { connect } from "react-redux";
import {
	typeClient,
	pagedClient,
	searchClient,
	groupedCustomers,
} from "../../actions/client";
import CountUp from "react-countup";
import {
	Button,
	Card,
	Checkbox,
	Col,
	Flex,
	Modal,
	notification,
	Row,
	Skeleton,
	Statistic,
	Tag,
	Typography,
} from "antd";
import {
	CustomSearch,
	CustomSpinner,
	CustomTable,
} from "../utils/CustomComponents";
import {
	DownloadOutlined,
	EditFilled,
	FileExcelOutlined,
	FilePdfFilled,
} from "@ant-design/icons";
import { franchises57ClientsOptions } from "../../constants/Customer";
import axios from "axios";
import { api } from "../utils/Api";
import { useRef } from "react";
import JobPerformanceBody from "../job/JobPerformanceBody";
import CustomersByType from "./CustomerByType";
const { Title, Text } = Typography;

const formatter = (value) => <CountUp end={value} duration={2} separator="," />;

const ClientList = ({
	history,
	typeClient,
	pagedClient,
	searchClient,
	groupedCustomers,
	client: { clients, group },
}) => {
	const [newCustomer, setNewCustomer] = useState(0);
	const [devCustomer, setDevCustomer] = useState(0);
	const [porCustomer, setPorCustomer] = useState(0);
	const [tableLoading, setTableLoading] = useState(true);
	const [loading, setLoading] = useState(false);
	const [customerList, setCustomerList] = useState([]);
	const [franchise, setFranchise] = useState("57Concrete");
	const [apiNotification, contextHolder] = notification.useNotification();

	const [openJobPerformance, setOpenJobPerformance] = useState(false);
	const customerId = useRef(null);
	const [openModalCustomerByType, setOpenModalCustomerByType] = useState(false);

	const openNotification = (type, message, description) => {
		apiNotification[type]({
			message: message,
			description: description,
		});
	};

	/**
	 ** Options header (columns)
	 */
	const columns = [
		{
			title: "",
			dataIndex: "edit",
			// width: 250,
			render: (_, record) => {
				return (
					<Flex gap={10} justify="space-between">
						<Button
							type="primary"
							icon={<EditFilled twoToneColor={"white"} />}
							onClick={(e) => history.push(`/customer/profile/${record.id}`)}
						/>
						<Button
							type="primary"
							onClick={() => {
								customerId.current = record.id;
								setOpenJobPerformance(true);
							}}
						>
							Job Performance
						</Button>
						{record.hasCreditApplication && (
							<Button
								type="primary"
								danger
								icon={<FilePdfFilled twoToneColor={"white"} />}
								onClick={() => {
									const link = document.createElement("a");
									link.href = record.creditApplication;
									link.target = "_blank";
									document.body.appendChild(link);
									link.click();
									link.remove();
								}}
							>
								Credit Application
							</Button>
						)}
						{/* <Button
							type="primary"
							color="red"
							onClick={(e) => history.push(`/clientsummary/${record.id}`)}
						>
							Summary
						</Button> */}
					</Flex>
				);
			},
		},
		{
			title: "Customer",
			dataIndex: "name",
			key: "name",
			render: (value) => {
				return <Text>{value}</Text>;
			},
		},
		{
			title: "Address",
			dataIndex: "address",
			key: "address",
			render: (value) => {
				return <Text>{value}</Text>;
			},
		},
		{
			title: "Phone",
			dataIndex: "phone",
			key: "phone",
			render: (value) => {
				return <Text>{value}</Text>;
			},
		},
		{
			title: "Type",
			dataIndex: "type",
			key: "type",
			render: (value) => {
				return <Text>{value}</Text>;
			},
		},
		{
			title: "Classification",
			dataIndex: "classification",
			key: "classification",
			render: (value) => {
				return <Text>{value}</Text>;
			},
		},
		{
			title: "Primary Contact Information",
			dataIndex: "contactInfo",
			key: "contactInfo",
			render: (value) => {
				return <Checkbox checked={value} />;
			},
		},
		{
			title: "Company Address Information",
			dataIndex: "companyInfo",
			key: "companyInfo",
			render: (value) => {
				return <Checkbox checked={value} />;
			},
		},
		{
			title: "Primary A/P Contact Information",
			dataIndex: "primaryAPContactInfo",
			key: "primaryAPContactInfo",
			render: (value) => {
				return <Checkbox checked={value} />;
			},
		},
		{
			title: "Is Credit?",
			dataIndex: "isCredit",
			key: "isCredit",
			render: (value) => {
				return <Checkbox checked={value} />;
			},
		},
		{
			title: "W-9 Form",
			dataIndex: "hasW9Form",
			key: "hasW9Form",
			render: (value) => {
				return <Checkbox checked={value} />;
			},
		},
		{
			title: "Phone Quote",
			dataIndex: "phoneQuote",
			key: "phoneQuote",
			render: (value) => {
				return <Checkbox checked={value} />;
			},
		},
		{
			title: "Franchise",
			dataIndex: "franchise",
			key: "franchise",
			render: (value) => {
				return (
					<Tag
						color={
							value === "57Concrete" || value === null || value === undefined
								? "blue"
								: "green"
						}
					>
						{value}
					</Tag>
				);
			},
		},
		{
			title: "Credit Hold",
			dataIndex: "creditHold",
			key: "creditHold",
			render: (value, record) => {
				if (
					localStorage.getItem("email") === "mv@57concrete.com" ||
					localStorage.getItem("email") === "al@57concrete.com" ||
					localStorage.getItem("email") === "ec@57concrete.com" ||
					localStorage.getItem("email") === "mgr@57concrete.com" ||
					localStorage.getItem("email") === "cdl@57concrete.com" ||
					localStorage.getItem("email") === "bp@57concrete.com" ||
					localStorage.getItem("email") === "bpa@57concrete.com" ||
					localStorage.getItem("email") === "mb@57concrete.com" ||
					localStorage.getItem("email") === "vo@57concrete.com" ||
					localStorage.getItem("email") === "wc@57concrete.com" ||
					localStorage.getItem("email") === "bm@57concrete.com" ||
					localStorage.getItem("email") === "eliud@gmail.com" ||
					localStorage.getItem("email") === "pc@57concrete.com" ||
					localStorage.getItem("email") === "gg@57xgroup.com" ||
					localStorage.getItem("email") === "scale@filegonia.com" ||
					localStorage.getItem("email") === "jc@57concrete.com" ||
					localStorage.getItem("email") === "reyesss22@icloud.com" ||
					localStorage.getItem("email") === "office@57logistics.com"
				) {
					return (
						<Checkbox
							checked={value}
							onChange={(e) => updateHoldCredit(record.id, e.target.checked)}
						/>
					);
				}

				return <Checkbox checked={value} />;
			},
		},
	];

	const updateHoldCredit = async (id, value) => {
		setLoading(true);
		const url = api + "/customer/" + id;
		const token = localStorage.getItem("token");
		axios.defaults.headers.common = { Authorization: `Bearer ${token}` };

		try {
			const body = {
				creditHold: value,
			};
			await axios.patch(url, body);
			setCustomerList((prev) =>
				prev.map((customer) =>
					customer.id === id ? { ...customer, creditHold: value } : customer,
				),
			);
			openNotification("info", "Info", "Credit Hold Updated");
			setLoading(false);
		} catch (err) {
			setLoading(false);
			console.error(err.message);
			return null;
		}
	};

	useEffect(() => {
		const initialCustomer = 0;
		const endCustomer = 15;
		groupedCustomers(franchise);
		pagedClient(initialCustomer, endCustomer, franchise);
	}, []);

	useEffect(() => {
		getCount();
	}, [group]);

	useEffect(() => {
		setTableLoading(true);
		assignCustomerList();
	}, [clients]);

	const assignCustomerList = () => {
		if (clients) {
			let list = [];
			clients.map((item, index) => {
				list.push({
					key: index,
					id: item._id,
					name: item.customerNumber + " " + item.name,
					address: item.address,
					phone: item.contactPhone ? item.contactPhone : "",
					type: item.customerType,
					classification: item.classification,
					creditHold: item.creditHold ? item.creditHold : false,
					phoneQuote: item.isProspect ? item.isProspect : false,
					franchise: item.franchise || "57Concrete",
					contactInfo: item.sms && item.email && item.contactName,
					companyInfo: item.address && item.city && item.state && item.zip,
					primaryAPContactInfo:
						item.accountsPayableContact && item.accountsPayablePhone,
					isCredit: item.paymentType === "Credit",
					hasW9Form: item.signedW9Form ? true : false,
					hasCreditApplication: item.creditApplication ? true : false,
					creditApplication: item.creditApplication,
				});
			});
			setCustomerList(list);
		} else {
			setCustomerList([]);
		}
		setTableLoading(false);
	};

	const getClassCustomers = async (type) => {
		await typeClient(type, franchise);
	};

	const onSearch = async (value, _e, info) => {
		if (info?.source === "input") {
			setLoading(true);
			await searchClient(value, franchise);
			await groupedCustomers(franchise);
			setLoading(false);
		}
	};

	const onChangeFranchise = (value) => {
		setFranchise(value);
	};

	const getCount = () => {
		if (typeof group !== "undefined") {
			group.forEach((item) => {
				if (item._id === "new") {
					setNewCustomer(item.count);
				} else if (item._id === "development") {
					setDevCustomer(item.count);
				} else {
					setPorCustomer(item.count);
				}
			});
			if (group.length === 1) {
				setDevCustomer(0);
				setPorCustomer(0);
			}
		}
	};
	const RenderSearch = () => {
		return (
			<Flex gap={16} justify="space-between">
				<CustomSearch
					loading={loading}
					onSearch={onSearch}
					pickerValue={franchise}
					defaultValuePicker={"57Concrete"}
					onChangePicker={onChangeFranchise}
					optionsPicker={franchises57ClientsOptions}
					allowClearPicker={false}
					pickerWidth={"100%"}
					disabledPicker={loading}
					labelPicker={"Franchise"}
				/>
				<Flex gap={"middle"}>
					{(localStorage.getItem("email") === "ec@57concrete.com" ||
						localStorage.getItem("email") === "jp@57concrete.com" ||
						localStorage.getItem("email") === "vc@57concrete.com" ||
						localStorage.getItem("email") === "eliud@gmail.com") && (
						<Button
							onClick={() => setOpenModalCustomerByType(true)}
							type="primary"
							size="large"
							icon={<FileExcelOutlined />}
							disabled={loading}
							loading={loading}
						>
							Customers By Type Report
						</Button>
					)}
					<Button
						onClick={downloadPdfFormat}
						type="primary"
						size="large"
						disabled={loading}
						loading={loading}
						icon={<DownloadOutlined />}
					>
						Download Credit Application Format
					</Button>
				</Flex>
			</Flex>
		);
	};

	const ClientTable = () => (
		<Flex gap={"middle"} vertical>
			<CustomTable columns={columns} data={customerList} loading={loading} />
		</Flex>
	);

	const onClickGrouped = async (grouped) => {
		setLoading(true);
		await getClassCustomers(grouped);
		setLoading(false);
	};

	const ClientGroup = () => (
		<>
			<Row gutter={16}>
				<Col span={8}>
					<Card
						bordered
						style={{ backgroundColor: "#1D64E2", cursor: "pointer" }}
						onClick={(e) => onClickGrouped("new")}
					>
						{loading ? (
							<Skeleton active />
						) : (
							<Flex align="center" justify="center" vertical>
								<Title level={2} style={{ color: "white" }}>
									New Customers
								</Title>
								<Text>
									<Statistic
										title="Customers"
										value={newCustomer}
										formatter={formatter}
										valueStyle={{ color: "white" }}
									/>
								</Text>
							</Flex>
						)}
					</Card>
				</Col>
				<Col span={8}>
					<Card
						bordered
						style={{ backgroundColor: "#E21D64", cursor: "pointer" }}
						onClick={(e) => onClickGrouped("development")}
					>
						{loading ? (
							<Skeleton active />
						) : (
							<Flex align="center" justify="center" vertical>
								<Title level={2} style={{ color: "white" }}>
									Development
								</Title>
								<Row
									gutter={16}
									justify={"center"}
									align={"middle"}
									style={{ width: "100%" }}
								>
									<Col span={6}>
										<Text>
											<Statistic
												title="Customers"
												value={devCustomer}
												formatter={formatter}
												valueStyle={{ color: "white" }}
											/>
										</Text>
									</Col>
								</Row>
							</Flex>
						)}
					</Card>
				</Col>
				<Col span={8}>
					<Card
						bordered
						style={{ backgroundColor: "green", cursor: "pointer" }}
						onClick={(e) => onClickGrouped("portfolio")}
					>
						{loading ? (
							<Skeleton active />
						) : (
							<Flex align="center" justify="center" vertical>
								<Title level={2} style={{ color: "white" }}>
									Portfolio
								</Title>
								<Text>
									<Statistic
										title="Customers"
										value={porCustomer}
										formatter={formatter}
										valueStyle={{ color: "white" }}
									/>
								</Text>
							</Flex>
						)}
					</Card>
				</Col>
			</Row>
		</>
	);

	const downloadPdfFormat = () => {
		const link = document.createElement("a");
		link.href = "https://jap-photo.s3.amazonaws.com/credit/CreditForm.pdf";
		link.target = "_blank";
		document.body.appendChild(link);
		link.click();
		link.remove();
	};

	const RenderModal = () => {
		return (
			<Modal
				title={`Job Performance`}
				open={openJobPerformance}
				onCancel={() => {
					setOpenJobPerformance(false);
					customerId.current = null;
				}}
				footer={null}
				width={1400}
				destroyOnClose
				centered
			>
				<JobPerformanceBody hasClient={true} customerId={customerId.current} />
			</Modal>
		);
	};

	const RenderModalCustomerByType = () => {
		return (
			<Modal
				title={`Customers By Type`}
				open={openModalCustomerByType}
				onCancel={() => {
					setOpenModalCustomerByType(false);
				}}
				footer={null}
				width={500}
				destroyOnClose
				centered
			>
				<CustomersByType />
			</Modal>
		);
	};

	return (
		<Layout title="Customer" description="">
			<RenderSearch />
			<ClientGroup />
			{tableLoading ? <CustomSpinner /> : <ClientTable />}
			{contextHolder}
			<RenderModal />
			<RenderModalCustomerByType />
		</Layout>
	);
};

const mapStateToProps = (state) => ({
	client: state.client,
});

export default connect(mapStateToProps, {
	typeClient,
	pagedClient,
	searchClient,
	groupedCustomers,
})(ClientList);
